import { Pagination } from '@malesia/react-components/dist/src/components/Pagination';
import { TableFooter } from '@malesia/react-components/dist/src/components/Table/TableFooter';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectList, selectPagination } from '../store/selectors';
import { actions } from '../store/slice';
import { AllotmentCreateInvoiceButtonWithStore } from './AllotmentCreateInvoiceButtonWithStore';

export const AllotmentListFooterWithStore: SFC = () => {
    const dispatch = useDispatch();
    const tableData = useSelector(selectList);
    const pagination = useSelector(selectPagination);

    return (
        <TableFooter
            actionsSlot={<AllotmentCreateInvoiceButtonWithStore />}
            paginationSlot={
                <Pagination
                    total={tableData.total}
                    pageTotal={tableData.items.length}
                    pagination={pagination}
                    maxPageSize={500}
                    setPage={(data) => {
                        dispatch(actions.setPage(data));
                    }}
                    setPageSize={(data) => {
                        dispatch(actions.setPageSize(data));
                    }}
                />
            }
        />
    );
};
